module.exports = __webpack_public_path__ + "img/AGR-A-2-I.12ae8c61.png";